const PanelModelEnum = Object.freeze({
    NAO_INFORMADO: "NÃO INFORMADO",
    NORMAL: "MODO NORMAL",
    PARCIAL: "MODO PARCIAL",
    SSPAUTO: "SOFTSPARE PANEL ATIVO EM MODO AUTOMÁTICO",
    SSPMANUAL: "SOFTSPARE PANEL ATIVO EM MODO MANUAL"
});

export default PanelModelEnum;